import type { SelectProps } from '../Select.types'

import { selectFilterAdapters } from './selectFilterAdapters'

type Params = {
  options: SelectProps['options']
  searchAdapter: SelectProps['searchAdapter']
  searchValue: string
  shouldFilter: boolean
}

export const filterSelectOptions = ({
  options,
  searchAdapter = 'startingWith',
  searchValue,
  shouldFilter
}: Params) => {
  if (!searchValue || !shouldFilter) {
    return options
  }

  const filterAlgorithm = selectFilterAdapters[searchAdapter]

  return filterAlgorithm({
    search: searchValue,
    options
  })
}
